import type {DataGridRow} from '@dms/api/core';

import {DATA_GRID_KEY_VALUE_SCHEMA, readDataGridCell} from './readDataGridCell';

export function readDataGridCellKey(row: DataGridRow, keys: readonly string[]) {
  const result = DATA_GRID_KEY_VALUE_SCHEMA.safeParse(readDataGridCell(row, keys));

  return result.success ? result.data.key : undefined;
}
